import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { OTP_medium } from 'src/app/helper/interface/user';

@Injectable({
  providedIn: 'root',
})
export class AuthApiService {
  constructor(private http: HttpClient) {}

  otpSend(num: any, medium: OTP_medium, type = 'LOGIN') {
    return lastValueFrom(this.http.get(`auth/sendOTP/${num}/${medium}`));
  }
  resendOtp(num: any, medium: OTP_medium, type = 'LOGIN') {
    return lastValueFrom(this.http.get(`auth/sendOTP/${num}/${medium}`));
    // return lastValueFrom(this.http.get(`/resendOTP/${num}/${medium}/${type}`));
  }
  login(data: any) {
    return lastValueFrom(this.http.post(`/auth/login`, data));
  }
  getRolePermission(data: any) {
    return lastValueFrom(this.http.get(`/getAllPermission/${data}`));
  }
  loginOTP(data: any) {
    return lastValueFrom(this.http.post(`/auth/loginVerifyOtp`, data));
  }
  changePassword(data: any) {
    return lastValueFrom(this.http.post(`/users/changePassword`, data));
  }

  getRoleById(id: number | string) {
    return lastValueFrom(this.http.get(`/role/getById/${id}`));
  }

  saveRolePermission(data: any, id: string) {
    return lastValueFrom(this.http.post(`/role/updatePermission/${id}`, data));
  }
  getRolePermissionByRole(id: any, isFull = false) {
    if (isFull) {
      return lastValueFrom(this.http.get(`/role/getPermissionFull/${id}`));
    } else {
      return lastValueFrom(this.http.get(`/role/getPermission/${id}`));
    }
  }
}
